import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare const require: any;
const jsPDF = require('jspdf');

@Injectable()
export class ExportFileService {
  list: any[] = [];

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    this.list = [];
    const empresa = sessionStorage.getItem('empresa_nombre');
    this.list.push({
      '     ': 'TNK CONTABILIDAD', '': '', ' ' : empresa, '  ': '', '   ': '', '    ': ''
    }, {
      '     ': '', '': '', ' ': 'REPORTE AUXILIAR DE MOVIMIENTOS', '  ': '', '   ': '', '    ': ''
      }, {
        '     ': 'Póliza', '': 'Fecha', ' ': 'Concepto','  ': 'Saldo Inicial' , '   ': 'Cargos', '    ': 'Abonos', '      ': 'Saldo Final'
      }
    );
    for (const item of json) {
      this.list.push({
        '     ': item.folio, '': item.fecha,
        ' ': item.descripcion,'  ': item.saldo_inicial, '   ': item.cargo, '    ': item.abono, '      ': item.saldo_final
      })
    }
    const worksheet: XLSX.WorkSheet =
      XLSX.utils.json_to_sheet(this.list);
    const wscols = [{ width: 20 }, { width: 20 } , { width: 32 }, { width: 18 }, { width: 18 }
    ];
    worksheet['!cols'] = wscols;
    const workbook: XLSX.WorkBook = { Sheets: { 'Cuentas': worksheet }, SheetNames: ['Cuentas'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }



  public exportAsPDF(json: any[], excelFileName: string): void {
    this.list = [];
    const doc = new jsPDF();

    for (const item of json) {
      this.list.push([
        //item.folio, item.fecha, item.cuenta, item.nom_cuenta, item.descripcion, item.cargos, item.abonos, item.saldo
        item.folio, item.fecha, item.descripcion, item.cargos, item.abonos, item.saldo
      ]);
    }

    doc.setProperties({title: 'REPORTE AUXILIAR DE MOVIMIENTOS'});
    //doc.viewerPreferences({'DisplayDocTitle': true});

    doc.autoTable({
      columnStyles: {europe: {halign: 'center'}},
      //head: [['Póliza', 'Fecha', 'Cuenta', 'Nombre de la cuenta', 'Descripción', 'Cargos', 'Bonos', 'Saldo']],
      head: [['Folio', 'Fecha', 'Descripción', 'Cargos', 'Bonos', 'Saldo']],
      body: this.list,
      didDrawPage: function(data) {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(1, '0');
        const yy = today.getFullYear();

        const hoy = mm + '/' + dd + '/' + yy;

        doc.setFont('Condensed');
        doc.setFontType('Bahnschrift');
        doc.setFontSize(14);
        let fileTitle = sessionStorage.getItem('empresa_nombre');
        doc.text(fileTitle, 120, 15);

        doc.setFont('Condensed');
        doc.setFontType('Bahnschrift');
        doc.setFontSize(14);
        fileTitle = 'CONTABILIDAD';
        doc.text(fileTitle, 10, 15);
        // Header
        doc.setFont('Light');
        doc.setFontType('Calibri');
        doc.setFontSize(12);
        fileTitle = 'REPORTE AUXILIAR DE MOVIMIENTOS';
        doc.text(fileTitle, 70, 30);

        const pageSize = doc.internal.pageSize;
        const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        let str = 'Pagina ' + doc.internal.getNumberOfPages()

        if (typeof doc.putTotalPages === 'function') {
          str = str + '                                                                                                                                                                              ' + hoy;
        }
        doc.setFontSize(10);
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      },
      margin: {
        bottom: 60,
        top: 40
      }
    });
    const finalY = doc.previousAutoTable.finalY;
    doc.save(excelFileName + '.pdf');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
}
